export default __webpack_public_path__ + "static/media/mca_logo_new.ef480217.png";